const ptBR = {
  metaTitle: 'Aplicativos Mobile Profissionais | WSJ Soluções Digitais',
  badge: 'Aplicativos Mobile',
  heroTitle: 'Aplicativos mobile profissionais para Android e iOS.',
  heroSubtitle:
    'Criamos apps híbridos modernos, conectados à sua operação e preparados para crescer com o seu negócio.',
  heroBadges: [
    'Android',
    'iOS',
    'App híbrido',
    'Play Store',
    'App Store',
    'Push notifications',
    'APIs',
    'Painel administrativo'
  ],
  btnQuote: 'Solicitar orçamento',
  btnWhatsapp: 'Falar no WhatsApp',
  btnPlans: 'Ver planos',
  whatsappMessage: 'Olá! Gostaria de um orçamento para aplicativo mobile com a WSJ.',

  sectionProblemsTitle: 'Quando um aplicativo faz sentido para sua empresa?',
  sectionProblemsClose:
    'Um aplicativo só faz sentido quando resolve um problema real da operação ou melhora a experiência do cliente.',
  problemItems: [
    { title: 'Atendimento recorrente', desc: 'Clientes que precisam voltar com frequência e merecem uma experiência dedicada.' },
    { title: 'Clientes precisam voltar ao app', desc: 'Fidelização, histórico, área logada e jornada contínua com a marca.' },
    { title: 'Agendamentos frequentes', desc: 'Reservas, consultas ou serviços com fluxo recorrente no celular.' },
    { title: 'Pedidos organizados', desc: 'Operação que se beneficia de app com status, notificações e controle.' },
    { title: 'Notificações push', desc: 'Comunicação direta com o cliente sobre status, promoções ou lembretes.' },
    { title: 'Área do cliente', desc: 'Login, histórico, documentos ou acompanhamento personalizado.' },
    { title: 'Operação com login', desc: 'Processos internos ou externos que exigem autenticação e permissões.' },
    { title: 'Integração com sistemas', desc: 'Conexão com backend, ERP, pagamentos ou ferramentas já existentes.' }
  ],

  sectionHybridTitle: 'Uma base moderna para Android e iOS',
  sectionHybridLead:
    'Desenvolvemos aplicativos híbridos modernos, permitindo criar soluções para Android e iOS com uma base tecnológica eficiente, reduzindo retrabalho e acelerando a entrega.',
  sectionHybridDesc:
    'Com tecnologia híbrida, conseguimos desenvolver uma base principal do aplicativo e adaptar a entrega para Android e iOS, reduzindo retrabalho e mantendo uma experiência profissional.',
  hybridAndroidTitle: 'Android',
  hybridAndroidDesc: 'Publicação na Google Play Store, conforme requisitos da plataforma.',
  hybridIosTitle: 'iOS',
  hybridIosDesc: 'Publicação na Apple App Store, conforme regras e análise da Apple.',
  hybridBackendTitle: 'Backend e APIs',
  hybridBackendDesc: 'O app pode ser conectado a banco de dados, painel administrativo, sistemas internos e integrações externas.',
  hybridNote:
    'A publicação nas lojas depende das regras da Google e da Apple. A WSJ auxilia no processo, mas a aprovação final é feita pelas plataformas oficiais.',

  sectionUseCasesTitle: 'Aplicativos para diferentes tipos de negócio',
  sectionUseCasesLead: 'Do agendamento ao app personalizado — estruturamos a solução conforme a operação.',
  useCases: [
    { title: 'App de agendamento', desc: 'Reservas, horários e confirmações no celular.' },
    { title: 'App de pedidos', desc: 'Fluxo de pedidos com status e notificações.' },
    { title: 'App para delivery', desc: 'Operação mobile para entregas e acompanhamento.' },
    { title: 'App para clientes', desc: 'Área exclusiva com login e histórico.' },
    { title: 'App interno para equipe', desc: 'Ferramenta operacional para colaboradores.' },
    { title: 'App com painel administrativo', desc: 'Gestão centralizada de conteúdo e operação.' },
    { title: 'App com notificações', desc: 'Push notifications para engajamento e avisos.' },
    { title: 'App com pagamentos', desc: 'Integração com gateways conforme escopo.' },
    { title: 'App com login', desc: 'Autenticação segura e controle de acesso.' },
    { title: 'App com catálogo', desc: 'Produtos ou serviços organizados no mobile.' },
    { title: 'App para serviços', desc: 'Jornada completa para prestadores e clientes.' },
    { title: 'App personalizado', desc: 'Solução sob medida para regras específicas.' }
  ],

  sectionDeliverablesTitle: 'Uma solução mobile completa, do app à publicação',
  sectionDeliverablesLead: 'Do design à operação — tudo estruturado com padrão profissional WSJ.',
  deliverables: [
    { title: 'Design mobile premium', desc: 'Interface pensada para uso real no celular.' },
    { title: 'App híbrido', desc: 'Base eficiente para Android e iOS.' },
    { title: 'Android e iOS', desc: 'Entrega conforme escopo e orçamento definidos.' },
    { title: 'Login e autenticação', desc: 'Acesso seguro para clientes ou equipe.' },
    { title: 'Banco de dados', desc: 'Persistência de dados conforme necessidade do projeto.' },
    { title: 'APIs', desc: 'Integração com backend e serviços externos.' },
    { title: 'Push notifications', desc: 'Comunicação direta com usuários do app.' },
    { title: 'Painel administrativo', desc: 'Gestão de conteúdo, pedidos ou operação.' },
    { title: 'Integrações', desc: 'Conexão com sistemas já existentes.' },
    { title: 'Publicação assistida', desc: 'Apoio no processo de submissão às lojas.' },
    { title: 'Testes', desc: 'Validação em dispositivos antes do go-live.' },
    { title: 'Suporte técnico', desc: 'Acompanhamento conforme plano contratado.' }
  ],

  sectionCostsTitle: 'Transparência sobre custos de publicação e infraestrutura',
  sectionCostsLead:
    'Custos externos não devem ser escondidos. A WSJ trabalha com transparência para o cliente entender o investimento real antes de iniciar.',
  sectionCostsIntro:
    'Google Play e Apple App Store podem exigir contas de desenvolvedor. A Apple possui custos e regras mais rigorosas. Alguns projetos precisam de servidores, banco de dados, storage, APIs ou serviços externos — tudo definido antes em proposta.',
  costItems: [
    { title: 'Conta Google Play', desc: 'Taxa de conta de desenvolvedor Google, quando aplicável.' },
    { title: 'Conta Apple Developer', desc: 'Programa Apple Developer com custo e regras próprias.' },
    { title: 'Servidor / backend', desc: 'Hospedagem, APIs e infraestrutura conforme escala.' },
    { title: 'Banco de dados', desc: 'Storage e serviços de dados externos, se necessário.' },
    { title: 'APIs externas', desc: 'Serviços pagos de terceiros integrados ao app.' },
    { title: 'Manutenção e atualizações', desc: 'Evoluções, correções e compatibilidade com lojas.' }
  ],
  costsHighlight:
    'Custos de contas de desenvolvedor, taxas das lojas, servidores, APIs pagas ou serviços externos não estão incluídos nos planos, salvo quando indicado em proposta.',

  sectionProcessTitle: 'Como funciona o processo',
  sectionProcessLead: 'Um caminho claro da ideia à publicação — com transparência em cada etapa.',
  processSteps: [
    { title: 'Entendemos a ideia e o objetivo', desc: 'Mapeamos operação, usuários, plataformas e expectativas.' },
    { title: 'Definimos escopo, plataformas e custos externos', desc: 'Proposta clara com investimento, prazos e custos de terceiros.' },
    { title: 'Criamos design e arquitetura', desc: 'UX mobile, fluxos, telas e base técnica do projeto.' },
    { title: 'Desenvolvemos app, backend e integrações', desc: 'App híbrido, APIs, painel e conexões necessárias.' },
    { title: 'Testamos e auxiliamos na publicação', desc: 'Validação em dispositivos e apoio no processo das lojas.' }
  ],

  sectionPlansTitle: 'Planos para transformar sua ideia em aplicativo',
  sectionPlansLead: 'Do MVP à operação completa — estrutura mobile profissional com transparência.',
  plansBillingMonthly: 'Mensal',
  plansBillingAnnual: 'Anual',
  plansSaveBadge: 'Economize 17%',
  plansDisclaimer:
    'Os valores não incluem taxas das lojas, contas de desenvolvedor, serviços de terceiros, servidores dedicados, APIs pagas ou custos cobrados pela Apple, Google ou fornecedores externos.',
  plansDisclaimerExtra:
    'Projetos com regras de negócio avançadas, pagamentos, geolocalização, chat, multi-idioma, integrações complexas ou alta escala exigem análise técnica e orçamento personalizado.',
  planStartName: 'Mobile Start',
  planStartDesc: 'Ideal para validar uma primeira versão de aplicativo com escopo controlado.',
  planStartNote: 'Indicado para uma primeira versão. Publicação em uma plataforma.',
  planStartFeatures: [
    'App híbrido inicial',
    'Android ou iOS',
    'Até 5 telas principais',
    'Design mobile responsivo',
    'Login simples',
    'Integração básica com API',
    'Testes básicos',
    'Publicação assistida',
    'Suporte por email'
  ],
  planStartCta: 'Começar app',
  planGrowthName: 'Mobile Growth',
  planGrowthBadge: 'Mais popular',
  planGrowthDesc: 'Ideal para empresas que precisam de aplicativo Android e iOS com estrutura mais completa.',
  planGrowthFeatures: [
    'Tudo do Start',
    'Android e iOS',
    'Até 12 telas principais',
    'Push notifications',
    'Integração com backend',
    'Painel administrativo básico',
    'Banco de dados',
    'APIs',
    'Testes em dispositivos',
    'Suporte prioritário'
  ],
  planGrowthCta: 'Começar agora',
  planPremiumName: 'Mobile Premium',
  planPremiumBadge: 'Premium',
  planPremiumDesc: 'Ideal para empresas que precisam de aplicativo robusto, integrações avançadas e operação contínua.',
  planPremiumFeatures: [
    'App completo personalizado',
    'Android e iOS',
    'Telas sob medida',
    'Dashboard avançado',
    'Automações',
    'Integrações avançadas',
    'Arquitetura escalável',
    'Relatórios',
    'Consultoria técnica',
    'Atendimento dedicado',
    'SLA prioritário'
  ],
  planPremiumCta: 'Falar com especialista',

  sectionRealProjectsTitle: 'Experiência digital aplicada a projetos reais',
  sectionRealProjectsLead: 'A WSJ já ajuda empresas reais a construírem presença digital, lojas online e soluções profissionais.',
  realProjectsNote:
    'Alguns exemplos são projetos web e e-commerce já entregues pela WSJ. Aplicativos mobile seguem o mesmo padrão de qualidade, processo e cuidado técnico.',
  realProjectsVisitCta: 'Visitar site',
  realProjectBadgeInstitutional: 'Institucional',
  realProjectBadgeEcommerce: 'E-commerce',
  realProjects: [
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Presença digital',
      badge: 'institutional',
      desc: 'Projeto digital profissional com foco em autoridade, branding e operação online.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    },
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'Operação digital',
      badge: 'ecommerce',
      desc: 'Estrutura digital completa com catálogo, experiência do usuário e profissionalismo.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'Branding digital',
      badge: 'ecommerce',
      desc: 'Presença digital moderna com identidade visual premium e navegação profissional.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    }
  ],

  sectionFaqTitle: 'Perguntas frequentes',
  sectionFaqLead: 'Transparência total antes de investir no seu aplicativo mobile.',
  faqItems: [
    {
      q: 'O app pode ser Android e iOS?',
      a: 'Sim. Trabalhamos com apps híbridos que permitem entregar para Android e iOS. O escopo de cada plataforma é definido no plano e na proposta.'
    },
    {
      q: 'Vocês publicam na Play Store e App Store?',
      a: 'Sim. A WSJ auxilia no processo de publicação, preparando materiais e submissão conforme as regras de cada loja.'
    },
    {
      q: 'A aprovação nas lojas é garantida?',
      a: 'Não. A WSJ auxilia no processo de publicação, mas a aprovação final depende das regras e análises das lojas oficiais — Google e Apple.'
    },
    {
      q: 'A conta Apple Developer está incluída?',
      a: 'Não. Custos de contas de desenvolvedor, taxas das lojas e serviços externos não estão incluídos nos planos, salvo quando indicado em proposta.'
    },
    {
      q: 'Preciso pagar servidor ou backend?',
      a: 'Depende do projeto. Apps com banco de dados, APIs ou operação contínua podem exigir servidores ou serviços externos — tudo transparente na proposta.'
    },
    {
      q: 'O app pode ter painel administrativo?',
      a: 'Sim. Planos Growth e Premium incluem painel administrativo conforme escopo — para gestão de conteúdo, pedidos ou operação.'
    },
    {
      q: 'Vocês fazem manutenção depois da publicação?',
      a: 'Sim. Oferecemos suporte e evolução conforme plano contratado, incluindo ajustes, atualizações e acompanhamento técnico.'
    },
    {
      q: 'Posso começar com Android e depois lançar iOS?',
      a: 'Sim. O plano Start permite validar em uma plataforma. Depois é possível evoluir para Android e iOS conforme crescimento e orçamento.'
    }
  ],

  finalCtaTitle: 'Pronto para transformar sua ideia em aplicativo?',
  finalCtaSubtitle:
    'A WSJ ajuda sua empresa a criar uma solução mobile profissional, escalável e preparada para operação real.',

  heroMock: {
    appLabel: 'App mobile',
    loginLabel: 'Login seguro',
    pushLabel: 'Nova notificação',
    pushDesc: 'Seu pedido foi confirmado',
    dashboardLabel: 'Dashboard',
    storesLabel: 'Publicação',
    playStore: 'Play Store',
    appStore: 'App Store',
    metric: 'Ativo'
  }
};

const ptPT = {
  ...ptBR,
  metaTitle: 'Aplicações Mobile Profissionais | WSJ Soluções Digitais',
  badge: 'Aplicações Mobile',
  heroTitle: 'Aplicações mobile profissionais para Android e iOS.',
  heroSubtitle:
    'Criamos apps híbridos modernos, ligados à sua operação e preparados para crescer com o seu negócio.',
  btnPlans: 'Ver planos',
  sectionProblemsClose:
    'Uma aplicação só faz sentido quando resolve um problema real da operação ou melhora a experiência do cliente.',
  useCases: [
    { title: 'App de agendamento', desc: 'Reservas, horários e confirmações no telemóvel.' },
    { title: 'App de pedidos', desc: 'Fluxo de pedidos com estado e notificações.' },
    { title: 'App para delivery', desc: 'Operação mobile para entregas e acompanhamento.' },
    { title: 'App para clientes', desc: 'Área exclusiva com login e histórico.' },
    { title: 'App interno para equipa', desc: 'Ferramenta operacional para colaboradores.' },
    { title: 'App com painel administrativo', desc: 'Gestão centralizada de conteúdo e operação.' },
    { title: 'App com notificações', desc: 'Push notifications para envolvimento e avisos.' },
    { title: 'App com pagamentos', desc: 'Integração com gateways conforme âmbito.' },
    { title: 'App com login', desc: 'Autenticação segura e controlo de acesso.' },
    { title: 'App com catálogo', desc: 'Produtos ou serviços organizados no mobile.' },
    { title: 'App para serviços', desc: 'Jornada completa para prestadores e clientes.' },
    { title: 'App personalizado', desc: 'Solução sob medida para regras específicas.' }
  ],
  sectionCostsIntro:
    'Google Play e Apple App Store podem exigir contas de programador. A Apple possui custos e regras mais rigorosas. Alguns projetos precisam de servidores, base de dados, storage, APIs ou serviços externos — tudo definido antes em proposta.',
  costItems: [
    { title: 'Conta Google Play', desc: 'Taxa de conta de programador Google, quando aplicável.' },
    { title: 'Conta Apple Developer', desc: 'Programa Apple Developer com custo e regras próprias.' },
    { title: 'Servidor / backend', desc: 'Alojamento, APIs e infraestrutura conforme escala.' },
    { title: 'Base de dados', desc: 'Storage e serviços de dados externos, se necessário.' },
    { title: 'APIs externas', desc: 'Serviços pagos de terceiros integrados ao app.' },
    { title: 'Manutenção e atualizações', desc: 'Evoluções, correções e compatibilidade com lojas.' }
  ],
  realProjectsNote:
    'Alguns exemplos são projetos web e e-commerce já entregues pela WSJ. Aplicações mobile seguem o mesmo padrão de qualidade, processo e cuidado técnico.',
  faqItems: [
    { q: 'A app pode ser Android e iOS?', a: 'Sim. Trabalhamos com apps híbridos que permitem entregar para Android e iOS. O âmbito de cada plataforma é definido no plano e na proposta.' },
    { q: 'Publicam na Play Store e App Store?', a: 'Sim. A WSJ auxilia no processo de publicação, preparando materiais e submissão conforme as regras de cada loja.' },
    { q: 'A aprovação nas lojas é garantida?', a: 'Não. A WSJ auxilia no processo de publicação, mas a aprovação final depende das regras e análises das lojas oficiais — Google e Apple.' },
    { q: 'A conta Apple Developer está incluída?', a: 'Não. Custos de contas de programador, taxas das lojas e serviços externos não estão incluídos nos planos, salvo quando indicado em proposta.' },
    { q: 'Preciso pagar servidor ou backend?', a: 'Depende do projeto. Apps com base de dados, APIs ou operação contínua podem exigir servidores ou serviços externos — tudo transparente na proposta.' },
    { q: 'A app pode ter painel administrativo?', a: 'Sim. Planos Growth e Premium incluem painel administrativo conforme âmbito.' },
    { q: 'Fazem manutenção depois da publicação?', a: 'Sim. Oferecemos suporte e evolução conforme plano contratado.' },
    { q: 'Posso começar com Android e depois lançar iOS?', a: 'Sim. O plano Start permite validar numa plataforma. Depois é possível evoluir para Android e iOS.' }
  ],
  finalCtaSubtitle:
    'A WSJ ajuda a sua empresa a criar uma solução mobile profissional, escalável e preparada para operação real.'
};

const enUS = {
  metaTitle: 'Professional Mobile Apps | WSJ Soluções Digitais',
  badge: 'Mobile Apps',
  heroTitle: 'Professional mobile apps for Android and iOS.',
  heroSubtitle:
    'We build modern hybrid apps connected to your operations and ready to grow with your business.',
  heroBadges: [
    'Android',
    'iOS',
    'Hybrid app',
    'Play Store',
    'App Store',
    'Push notifications',
    'APIs',
    'Admin dashboard'
  ],
  btnQuote: 'Request a quote',
  btnWhatsapp: 'Talk on WhatsApp',
  btnPlans: 'View plans',
  whatsappMessage: 'Hello! I would like a quote for a mobile app with WSJ.',

  sectionProblemsTitle: 'When does an app make sense for your business?',
  sectionProblemsClose: 'An app only makes sense when it solves a real operational problem or improves customer experience.',
  problemItems: [
    { title: 'Recurring service', desc: 'Customers who return frequently and deserve a dedicated experience.' },
    { title: 'Customers need to return', desc: 'Loyalty, history, logged area and continuous brand journey.' },
    { title: 'Frequent bookings', desc: 'Reservations, appointments or services with recurring mobile flow.' },
    { title: 'Organised orders', desc: 'Operations that benefit from status, notifications and control.' },
    { title: 'Push notifications', desc: 'Direct communication about status, offers or reminders.' },
    { title: 'Customer area', desc: 'Login, history, documents or personalised tracking.' },
    { title: 'Login-based operations', desc: 'Internal or external processes requiring authentication.' },
    { title: 'System integration', desc: 'Connection with backend, ERP, payments or existing tools.' }
  ],

  sectionHybridTitle: 'A modern foundation for Android and iOS',
  sectionHybridLead:
    'We develop modern hybrid apps, enabling Android and iOS solutions with an efficient technology base, reducing rework and accelerating delivery.',
  sectionHybridDesc:
    'With hybrid technology, we build a main app foundation and adapt delivery for Android and iOS, reducing rework while maintaining a professional experience.',
  hybridAndroidTitle: 'Android',
  hybridAndroidDesc: 'Google Play Store publication, according to platform requirements.',
  hybridIosTitle: 'iOS',
  hybridIosDesc: 'Apple App Store publication, according to Apple rules and review.',
  hybridBackendTitle: 'Backend & APIs',
  hybridBackendDesc: 'The app can connect to databases, admin panels, internal systems and external integrations.',
  hybridNote:
    'Store publication depends on Google and Apple rules. WSJ assists in the process, but final approval is made by the official platforms.',

  sectionUseCasesTitle: 'Apps for different business types',
  sectionUseCasesLead: 'From booking to custom apps — we structure the solution for your operation.',
  useCases: [
    { title: 'Booking app', desc: 'Reservations, schedules and confirmations on mobile.' },
    { title: 'Ordering app', desc: 'Order flow with status and notifications.' },
    { title: 'Delivery app', desc: 'Mobile operation for deliveries and tracking.' },
    { title: 'Customer app', desc: 'Exclusive area with login and history.' },
    { title: 'Internal team app', desc: 'Operational tool for staff.' },
    { title: 'App with admin panel', desc: 'Centralised content and operation management.' },
    { title: 'App with notifications', desc: 'Push notifications for engagement and alerts.' },
    { title: 'App with payments', desc: 'Gateway integration according to scope.' },
    { title: 'App with login', desc: 'Secure authentication and access control.' },
    { title: 'Catalogue app', desc: 'Products or services organised on mobile.' },
    { title: 'Services app', desc: 'Complete journey for providers and customers.' },
    { title: 'Custom app', desc: 'Tailored solution for specific business rules.' }
  ],

  sectionDeliverablesTitle: 'A complete mobile solution, from app to publication',
  sectionDeliverablesLead: 'From design to operations — everything structured to WSJ professional standards.',
  deliverables: [
    { title: 'Premium mobile design', desc: 'Interface designed for real mobile use.' },
    { title: 'Hybrid app', desc: 'Efficient foundation for Android and iOS.' },
    { title: 'Android & iOS', desc: 'Delivery according to defined scope and budget.' },
    { title: 'Login & authentication', desc: 'Secure access for customers or team.' },
    { title: 'Database', desc: 'Data persistence according to project needs.' },
    { title: 'APIs', desc: 'Backend and external service integration.' },
    { title: 'Push notifications', desc: 'Direct communication with app users.' },
    { title: 'Admin dashboard', desc: 'Content, order or operation management.' },
    { title: 'Integrations', desc: 'Connection with existing systems.' },
    { title: 'Assisted publication', desc: 'Support in store submission process.' },
    { title: 'Testing', desc: 'Device validation before go-live.' },
    { title: 'Technical support', desc: 'Follow-up according to contracted plan.' }
  ],

  sectionCostsTitle: 'Transparency about publication and infrastructure costs',
  sectionCostsLead: 'External costs should not be hidden. WSJ works transparently so clients understand the real investment before starting.',
  sectionCostsIntro:
    'Google Play and Apple App Store may require developer accounts. Apple has stricter costs and rules. Some projects need servers, databases, storage, APIs or external services — all defined upfront in the proposal.',
  costItems: [
    { title: 'Google Play account', desc: 'Google developer account fee, when applicable.' },
    { title: 'Apple Developer account', desc: 'Apple Developer Program with its own costs and rules.' },
    { title: 'Server / backend', desc: 'Hosting, APIs and infrastructure according to scale.' },
    { title: 'Database', desc: 'Storage and external data services if needed.' },
    { title: 'External APIs', desc: 'Paid third-party services integrated into the app.' },
    { title: 'Maintenance & updates', desc: 'Evolutions, fixes and store compatibility.' }
  ],
  costsHighlight:
    'Developer account costs, store fees, servers, paid APIs or external services are not included in plans unless stated in the proposal.',

  sectionProcessTitle: 'How the process works',
  sectionProcessLead: 'A clear path from idea to publication — with transparency at every stage.',
  processSteps: [
    { title: 'We understand the idea and goal', desc: 'We map operations, users, platforms and expectations.' },
    { title: 'We define scope, platforms and external costs', desc: 'Clear proposal with investment, timeline and third-party costs.' },
    { title: 'We create design and architecture', desc: 'Mobile UX, flows, screens and technical foundation.' },
    { title: 'We build app, backend and integrations', desc: 'Hybrid app, APIs, panel and required connections.' },
    { title: 'We test and assist with publication', desc: 'Device validation and store process support.' }
  ],

  sectionPlansTitle: 'Plans to turn your idea into an app',
  sectionPlansLead: 'From MVP to full operation — professional mobile structure with transparency.',
  plansBillingMonthly: 'Monthly',
  plansBillingAnnual: 'Annual',
  plansSaveBadge: 'Save 17%',
  plansDisclaimer:
    'Prices do not include store fees, developer accounts, third-party services, dedicated servers, paid APIs or costs charged by Apple, Google or external providers.',
  plansDisclaimerExtra:
    'Projects with advanced business rules, payments, geolocation, chat, multi-language, complex integrations or high scale require technical analysis and a custom quote.',
  planStartName: 'Mobile Start',
  planStartDesc: 'Ideal for validating a first app version with controlled scope.',
  planStartNote: 'Recommended for a first version. Publication on one platform.',
  planStartFeatures: [
    'Initial hybrid app',
    'Android or iOS',
    'Up to 5 main screens',
    'Responsive mobile design',
    'Simple login',
    'Basic API integration',
    'Basic testing',
    'Assisted publication',
    'Email support'
  ],
  planStartCta: 'Start app',
  planGrowthName: 'Mobile Growth',
  planGrowthBadge: 'Most popular',
  planGrowthDesc: 'Ideal for businesses that need Android and iOS apps with more complete structure.',
  planGrowthFeatures: [
    'Everything in Start',
    'Android & iOS',
    'Up to 12 main screens',
    'Push notifications',
    'Backend integration',
    'Basic admin dashboard',
    'Database',
    'APIs',
    'Device testing',
    'Priority support'
  ],
  planGrowthCta: 'Get started',
  planPremiumName: 'Mobile Premium',
  planPremiumBadge: 'Premium',
  planPremiumDesc: 'Ideal for businesses that need a robust app, advanced integrations and continuous operation.',
  planPremiumFeatures: [
    'Fully custom app',
    'Android & iOS',
    'Tailored screens',
    'Advanced dashboard',
    'Automations',
    'Advanced integrations',
    'Scalable architecture',
    'Reports',
    'Technical consulting',
    'Dedicated account manager',
    'Priority SLA'
  ],
  planPremiumCta: 'Talk to a specialist',

  sectionRealProjectsTitle: 'Digital experience applied to real projects',
  sectionRealProjectsLead: 'WSJ already helps real businesses build digital presence, online stores and professional solutions.',
  realProjectsNote:
    'Some examples are web and e-commerce projects already delivered by WSJ. Mobile apps follow the same quality, process and technical care standards.',
  realProjectsVisitCta: 'Visit website',
  realProjectBadgeInstitutional: 'Corporate',
  realProjectBadgeEcommerce: 'E-commerce',
  realProjects: [
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Digital presence',
      badge: 'institutional',
      desc: 'Professional digital project focused on authority, branding and online operation.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    },
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'Digital operation',
      badge: 'ecommerce',
      desc: 'Complete digital structure with catalogue, user experience and professionalism.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'Digital branding',
      badge: 'ecommerce',
      desc: 'Modern digital presence with premium visual identity and professional navigation.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    }
  ],

  sectionFaqTitle: 'FAQ',
  sectionFaqLead: 'Full transparency before you invest in your mobile app.',
  faqItems: [
    { q: 'Can the app be Android and iOS?', a: 'Yes. We work with hybrid apps for both platforms. Each platform scope is defined in the plan and proposal.' },
    { q: 'Do you publish on Play Store and App Store?', a: 'Yes. WSJ assists in the publication process, preparing materials and submission according to each store\'s rules.' },
    { q: 'Is store approval guaranteed?', a: 'No. WSJ assists in the publication process, but final approval depends on official store rules and review — Google and Apple.' },
    { q: 'Is the Apple Developer account included?', a: 'No. Developer account costs, store fees and external services are not included unless stated in the proposal.' },
    { q: 'Do I need to pay for server or backend?', a: 'It depends on the project. Apps with databases, APIs or continuous operation may require servers or external services — all transparent in the proposal.' },
    { q: 'Can the app have an admin dashboard?', a: 'Yes. Growth and Premium plans include an admin panel according to scope.' },
    { q: 'Do you provide maintenance after publication?', a: 'Yes. We offer support and evolution according to the contracted plan.' },
    { q: 'Can I start with Android and launch iOS later?', a: 'Yes. The Start plan allows validation on one platform. You can evolve to Android and iOS as you grow.' }
  ],

  finalCtaTitle: 'Ready to turn your idea into an app?',
  finalCtaSubtitle: 'WSJ helps your business create a professional, scalable mobile solution ready for real operation.',

  heroMock: {
    appLabel: 'Mobile app',
    loginLabel: 'Secure login',
    pushLabel: 'New notification',
    pushDesc: 'Your order was confirmed',
    dashboardLabel: 'Dashboard',
    storesLabel: 'Publication',
    playStore: 'Play Store',
    appStore: 'App Store',
    metric: 'Active'
  }
};

const fallbackLocales = ['es', 'fr', 'it', 'hi', 'de', 'nl', 'ru', 'ar', 'zh-CN', 'zh-TW'];

export const mobileAppsPageByLang = {
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  en: enUS,
  ...Object.fromEntries(fallbackLocales.map((code) => [code, enUS]))
};
